{
  "version": 1,
  "asset_id": "95e22e70-af82-45f4-9332-dcd9c770b260",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/95e22e70-af82-45f4-9332-dcd9c770b260/band-dilated-esophagus-annotated-1268.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/95e22e70-af82-45f4-9332-dcd9c770b260/band-dilated-esophagus-annotated-1268.jpg",
  "original_filename": "band-dilated-esophagus-annotated-1268.jpg",
  "size": 87003,
  "content_type": "image/jpeg",
  "created_at": "2026-09-26T01:40:04Z"
}
